import { useState, useEffect } from "react";
import { useAtom } from "jotai";
import { message } from "antd";
import { updatePointSystem } from "@services/settings.services";
import { getUserProfile } from "@services/auth.services";
import { userProfileAtom } from "@store/user.store";
import { onEnabledReliance } from "../../../services/settings.services";

export const RelianceLogic = () => {
  const [profile, setUserProfile] = useAtom(userProfileAtom);
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (profile) {
      setEnabled(profile?.externalPayment);
    }
  }, [profile]);

  const onChangeToogle = async () => {
    setLoading(true);
    setEnabled(!enabled);
    const body = {
      partner_id: profile?.partnerId,
      org_id: profile?.orgId,
      enable: !enabled,
    };
    try {
      await onEnabledReliance(body);
      const user = await getUserProfile();
      setUserProfile(user);
      setLoading(false);
    } catch (err) {
      await message.error(`${err.data.message}`);
      setLoading(false);
    }
  };

  return {
    enabled,
    setEnabled,
    loading,
    onChangeToogle,
  };
};
